import attempt from 'lodash/fp/attempt'
import compose from 'lodash/fp/compose'
import cond from 'lodash/fp/cond'
import constant from 'lodash/fp/constant'
import fecha from 'fecha'
import isDate from 'lodash/fp/isDate'
import isError from 'lodash/fp/isError'
import isFinite from 'lodash/fp/isFinite'
import isString from 'lodash/fp/isString'
import stubTrue from 'lodash/fp/stubTrue'

export default function (date, parse_format = 'YYYY-MM-DD', result_format = 'DD.MM.YYYY') {

    return compose(

        // Im Fehlerfall `null` ansonsten das formatierte Datum
        cond([
            [isError, constant(null)],
            [stubTrue, date => date],
        ]),

        // Monat ausfuehren
        attempt,

        // Monad erstellen, das Datum in Format bringt
        date => () => fecha.format(date, result_format),

        // `Date`-Objet erstellen
        cond([
            [isFinite, date => new Date(date)],
            [isString, date => fecha.parse(date, parse_format)],
            [isDate,   date => date],
        ])

    )(date)

}
